import { useTranslation } from "react-i18next";
import styles from "./CopyToClipboard.module.scss";
import copy from "../../assets/icons/copy.svg";
import copyHover from "../../assets/icons/copy-hover.svg";
import done from "../../assets/icons/status-done.svg";
import { useClipboard } from "../../hooks/useClipboard";

const CopyToClipboard = ({ text, layout = "default" }: { text: string; layout?: "default" | "slim" }) => {
  const { copied, copyToClipboard } = useClipboard(5000);
  const { t } = useTranslation();

  return (
    <div className={styles.copyContainer} onClick={() => copyToClipboard(text)}>
      <span className={`${styles.common} ${layout === "default" ? styles.default : styles.slim}`}>{text}</span>
      {!copied ? (
        <img
          onMouseOver={(e) => (e.currentTarget.src = copyHover)}
          onMouseOut={(e) => (e.currentTarget.src = copy)}
          src={copy}
          alt={`copy ${text}`}
          className={`${styles.copyIcon} ${layout === "default" ? "" : styles.copyIconSlim}`}
        />
      ) : (
        <>
          <span>
            <img
              src={done}
              alt="done"
              className={`${styles.copyIcon} ${layout === "default" ? "" : styles.copyIconSlim}`}
            />
            {layout === "default" && t("Copied!")}
          </span>
        </>
      )}
    </div>
  );
};

export default CopyToClipboard;
